module.exports = __webpack_public_path__ + "img/aa336f5149af047ae048f14622fa0c8e.png";